import { Form, Input, Button } from 'antd'
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import {
  CenteredContainer,
  LargeMailIcon,
  SuccessTitle,
  SecondaryText,
  SmallSecondaryText,
  FormItemReduced,
  FormItemNoMargin,
  FullWidthButton,
  LinkButton,
} from './styles/ForgotPasswordFormStyles'

interface ForgotPasswordFormProps {
  onFinish: (values: { email: string }) => void
  onBack: () => void
  loading: boolean
  emailSent: boolean
}

export function ForgotPasswordForm({
  onFinish,
  onBack,
  loading,
  emailSent,
}: ForgotPasswordFormProps) {
  const [form] = Form.useForm()

  if (emailSent) {
    return (
      <CenteredContainer>
        <LargeMailIcon />
        <SuccessTitle level={4}>Check your email</SuccessTitle>
        <SecondaryText type="secondary">
          We've sent a password reset link to your email address. Click the link to set a new
          password.
        </SecondaryText>
        <SmallSecondaryText type="secondary">
          Don't see it? Check your spam folder.
        </SmallSecondaryText>
        <Button onClick={onBack} icon={<ArrowLeftOutlined />}>
          Back to login
        </Button>
      </CenteredContainer>
    )
  }

  return (
    <Form
      form={form}
      name="forgot-password"
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      size="large"
    >
      <SecondaryText type="secondary">
        Enter your email address and we'll send you a link to reset your password.
      </SecondaryText>

      <Form.Item
        name="email"
        rules={[
          { required: true, message: 'Please input your email!' },
          { type: 'email', message: 'Please enter a valid email!' },
        ]}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" autoComplete="email" />
      </Form.Item>

      <FormItemReduced>
        <FullWidthButton type="primary" htmlType="submit" loading={loading}>
          Send reset link
        </FullWidthButton>
      </FormItemReduced>

      <FormItemNoMargin>
        <LinkButton type="link" onClick={onBack} icon={<ArrowLeftOutlined />}>
          Back to login
        </LinkButton>
      </FormItemNoMargin>
    </Form>
  )
}
